import { Component, AfterViewInit, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { Equipment } from '../../context-discovery-services/models';

@Component({
  selector: 'adminapp-equipment-selector',
  templateUrl: './equipment-selector.component.html',
  styleUrls: ['./equipment-selector.component.scss']
})
export class EquipmentSelectorComponent implements AfterViewInit {

  equipmentSelectorDomRepeat: any;
  equipmentSelector: any;

  @Input()
  set equipmentList(listOfEquipments: Array<Equipment>) {
    if (!(this.equipmentSelectorDomRepeat && listOfEquipments)) {
      return;
    }
    this.equipmentSelectorDomRepeat.items = listOfEquipments;
  }

  @Input()
  set selectedEquipment(iri: string) {
    if (this.equipmentSelector) {
      setTimeout(() => {
        this.equipmentSelector.value = iri;
      }, 0);
    }
  }

  @Input()
  placeholder: string;

  @Input()
  isDisabled: boolean;

  @Input()
  label: string;

  @Output()
  equipmentSelected: EventEmitter<string> = new EventEmitter<string>();

  constructor(private elRef: ElementRef) { }

  ngAfterViewInit(): void {
    this.equipmentSelectorDomRepeat = this.elRef.nativeElement.querySelector('coretex-select dom-repeat');
    const mainSelector = this.elRef.nativeElement.querySelector('coretex-select');
    mainSelector.placeholder = this.placeholder;
    mainSelector.label = this.label;
    mainSelector.addEventListener('value-changed', this.onEquipmentSelected.bind(this));
    this.equipmentSelector = mainSelector;
  }

  onEquipmentSelected(event: any) {
    this.equipmentSelected.emit(event.detail.value);
  }

  reset() {
    this.equipmentSelector.value = null;
    this.equipmentSelector._markOption(null, false);
  }

  getSelectedValue() {
    return this.equipmentSelector.value;
  }

  getSelectedDisplayedValue() {
    return this.equipmentSelector.displayedValue;
  }
}
